import { InjectionToken } from '@angular/core';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils';
import { DatalayerHelper } from '../ib-datalayer-helper';

export const AJSAncillariesDatalayerHelper = new InjectionToken<DatalayerHelper>('DatalayerHelper');
export const AJSDatalayerHelperProvider = upgradeAJSServiceProvider('DatalayerHelper', AJSAncillariesDatalayerHelper);

export interface DatalayerHelperType extends DatalayerHelper {
}

